export const getUserLogedId = () => {
    let user = JSON.parse(localStorage.getItem('user'))
    return  user?user.id:null;

};
export const getDate = () => {
    const fechaActual = new Date();
    const year = fechaActual.getFullYear();
    const month = String(fechaActual.getMonth() + 1).padStart(2, '0'); // Sumamos 1 al mes ya que los meses comienzan desde 0
    const day = String(fechaActual.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;

};
function getTime() {
    const date = new Date();
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seg = date.getSeconds().toString().padStart(2, '0');

    return `${hours}:${minutes}:${seg}`;
}

export default {
  params: {
    wallet_type : null,
    year_month_from: null,
    include_account_no_manage_doc: '0',
    account_code : null,
    contact_id : null,
    contact_warehouse_id: null,
    files:[],
    acepted:null,
    approved:null,
    paid:null,
    function:null,
    year_month:null,
    year_month_up:null,
    fun_code:null,
    affects_prefix: null,
    affects_consecutive: null,
    quota_number: null,
    identification_contact: null
  },
  ag_grid:{
    selectedTheme:'ag-theme-balham'
  },
  modalTc:{
    show : false,
    cw_id:null
  },
  warehouses: [],
  concepts: [],
  functions: [],
  parameterContactWarehouse:[],
  conceptsParameters:[],
  wallet:[],
  transactions_wallet:[],
  wallet_types:[],
  accounts_bank:[],
  loading:{
    preloader:false,
    wallet:true,
    pay:false
  },

  // Datos generacion Egresos
  form_generate_expenses:{
    vouchertype_id:null,
    date:null,
    bank_document_number:null,
    observations:null,
    file: null,
    documentsIds:[],
    account_bank:null,
    account_bank_description:null,
  },
  created_documents:[],
  g_e_vouchers_types: [],
  tracings: [],
  tracing_fields:{
        id : null,
        tracing: null,
        time: getTime(),
        user_id: getUserLogedId(),
        date: getDate(),
        document_id : null
  }

};





// WEBPACK FOOTER //
// ./src/modules/receivable-report/state.js